import type { Profile } from "./contracts.js";

export const PERSONAL_ROOM_NAME = "frontier-personal";

/** Allocation remains owned after graduation; only unfinished training selects it now. */
export function activePersonalLocation(profile: Pick<Profile, "tutorial" | "personalLocationId">): string | null {
  if (profile.tutorial?.version !== 2 || profile.tutorial.docked) return null;
  if (!profile.personalLocationId) throw new Error("Не удалось подготовить учебную систему. Переподключись.");
  return profile.personalLocationId;
}
